import 'swagger-ui/dist/swagger-ui.css';

import { View } from 'vcc-ui';

import styles from './impl/swagger.styles';

const Swagger = () => <View extend={styles} id="swag" />;

export default Swagger;
